import { render } from "./Hasil.vue?vue&type=template&id=ebec3de4&scoped=true"
import script from "./Hasil.vue?vue&type=script&lang=js"
export * from "./Hasil.vue?vue&type=script&lang=js"

import "./Hasil.vue?vue&type=style&index=0&id=ebec3de4&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebec3de4"]])

export default __exports__